import { render, staticRenderFns } from "./AgendaMedica.vue?vue&type=template&id=20cdf6aa"
import script from "./AgendaMedica.vue?vue&type=script&lang=ts"
export * from "./AgendaMedica.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports